import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CardExpiringResponse {
  id: string;
  paymentMethodId: string;
  last4: string;
  brand: string;
  exp_month: number;
  exp_year: number;
  isDefault: boolean;
  isExpired: boolean;
  daysUntilExpiration: number;
  daysSinceExpiration: number;
  lastChecked: string;
  parent: Parent;
}

export interface Parent {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export type GetExpiringCardsParams = {
  activeOnly?: boolean;
};

export const getExpiringCardsAPI = async ({
  activeOnly = false,
}: GetExpiringCardsParams = {}) => {
  const response = await baseAPI.get<Array<CardExpiringResponse>>(
    `/studios/expiring-cards`,
    {
      params: {
        activeOnly,
      },
    },
  );

  return response.data;
};

export const useGetExpiringCards = ({
  activeOnly = false,
}: GetExpiringCardsParams = {}) => {
  return useQuery({
    queryKey: [KEYS.EXPIRING_CARDS, { activeOnly }],
    queryFn: () => getExpiringCardsAPI({ activeOnly }),
  });
};
